import { Trans } from '~/common/context';
import { Button, Flex, Icon, Text, Tooltip } from '@wyz/ui';
import { CarFeatureIcon } from '~/purchase/components';

import { TYRE_SPEC_ENUM } from '~/purchase/schemas';
import { IBaseTyreOffer } from '~/purchase/types';
import { isNil } from 'lodash-es';

type Props = {
  tyre: {
    prodInfo: IBaseTyreOffer['tyre']['prodInfo'];
    homologations: IBaseTyreOffer['tyre']['homologations'];
    specification: IBaseTyreOffer['tyre']['specification'];
    ean: IBaseTyreOffer['tyre']['ean'];
  };
  onDetail: () => void;
};

function OfferDescriptionCell({ tyre, onDetail }: Props) {
  return (
    <div className='d-flex justify-content-center flex-column'>
      <div className='p-2 text-center'>
        <Text heading='xs' weight='semi-bold' color='secondary'>
          {tyre.prodInfo && (
            <>
              {!isNil(tyre.homologations) && tyre.homologations.length !== 0 ? (
                <Tooltip
                  label={tyre.homologations
                    .map((homologation) => homologation.brand)
                    .join(', ')}
                >
                  <span>{tyre.prodInfo}</span>
                </Tooltip>
              ) : (
                <span>{tyre.prodInfo}</span>
              )}
            </>
          )}
        </Text>

        <Tooltip label={<Trans i18nKey='app.common.product.run_flat' />}>
          <Text heading='xs' weight='semi-bold' color='secondary'>
            {tyre.specification.rftext}
          </Text>
        </Tooltip>
        <Text color='primary'>
          <Flex alignItems='center' justifyContent='center'>
            {tyre.specification.electricId !==
              TYRE_SPEC_ENUM.ELECTRIC.DISABLED && (
              <Tooltip
                label={
                  <Trans i18nKey='app.purchase.search_page.filter.specificities.electric' />
                }
              >
                <span>
                  <CarFeatureIcon value='electric' size='xs' />
                </span>
              </Tooltip>
            )}
            {tyre.specification.eco === TYRE_SPEC_ENUM.ECO.ENABLED && (
              <Tooltip
                label={
                  <Trans i18nKey='app.purchase.search_page.filter.specificities.eco' />
                }
              >
                <span>
                  <CarFeatureIcon value='eco' size='xs' />
                </span>
              </Tooltip>
            )}
            {Boolean(tyre.specification.sportCompatibility) && (
              <Tooltip
                label={
                  <Trans i18nKey='app.purchase.search_page.filter.specificities.sport' />
                }
              >
                <span>
                  <CarFeatureIcon value='sport' size='xs' />
                </span>
              </Tooltip>
            )}
          </Flex>
        </Text>
      </div>

      <Button
        id={`${tyre.ean}-detail`}
        variant='tertiary-blue'
        size='xs'
        onClick={onDetail}
      >
        <Text
          component={Flex}
          heading='xs'
          weight='semi-bold'
          color='primary'
          alignItems='center'
          className='space-x-1'
        >
          <span>
            <Trans i18nKey='app.purchase.table.info_btn' />
          </span>
          <Icon icon='eye' size='xs' />
        </Text>
      </Button>
    </div>
  );
}

export default OfferDescriptionCell;
